import { Locale, Region } from '@peerless/ui-locale';

export function isCartEnabled(locale: Locale | Region) {
  return isPricingEnabled(locale);
}

export function isPricingEnabled({ region }: Locale | Region) {
  return ['US'].includes(region);
}

export function isEMEARegion({ region }: Locale | Region) {
  return ['UK', 'FR', 'DE'].includes(region);
}
